import React from "react";
import { useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import { APP_HEADER_HEIGHT } from "../settings";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const AppLoader = props => {
    const currentTheme = useSelector( state => state.currentTheme);
    const appLoader = useSelector(state => state.appLoader);
    
    if (!appLoader.isVisible)
        return null;

    let backgroundColor = appLoader.backgroundColor || currentTheme.bodyBg;
    let loader = Object.assign({ isVisible: true, size: "large", type: "infinite-spinner", color: "primary" }, appLoader.loader);
    let text = Object.assign({content: "", color: currentTheme.bodyText}, appLoader.text);

    return (
        <div className="app-loader-layout">
            <div className="app-loader">
                { loader.isVisible && <Loader size={loader.size || "large"} type={loader.type} themeColor={loader.color} />}
                { text.content && <div style={{color: text.color}}>{text.content}</div>}
            </div>
            <style>
                {`
                    .app-loader-layout
                    {
                        background-color: ${backgroundColor};
                        width: 100vw;
                        height: 100vh;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        z-index: 9999;
                        top:0;
                        left:0;                        
                    }

                    .app-loader
                    {
                        padding: 8px 24px;
                        border: 1px solid ${currentTheme.componentBorderColor};
                        border-radius: 6px;
                    }
                `}
            </style>
    </div>
    );    
}

export const StaticAppLoader = props => {
    const currentTheme = useSelector( state => state.currentTheme);
     const { t } = useTranslation();

    let backgroundColor = currentTheme.bodyBg;
    let loader = { isVisible: true, size: "large", type: "infinite-spinner", color: "primary" };
    let text = {content: t("appinit.loading"), color: currentTheme.bodyText};

    return (
        <div className="static-app-loader-layout">
            <div className="app-loader">
                <Loader size={"large"} type={"infinite-spinner"} themeColor={loader.color} />
                <div style={{fontSize: 13, color: currentTheme.primary}}> {t("appinit.loading")}</div>
            </div>
            <style>
                {`
                    .static-app-loader-layout
                    {
                        background-color: ${backgroundColor};
                        width: 100vw;
                        height: 100vh;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        z-index: 9999;
                        top:0;
                        left:0;          
                    }

                    .static-app-loader
                    {
                        position: absolute;
                        padding: 0;
                        border: 1px solid ${currentTheme.componentBorderColor};
                        border-radius: 6px;
                    }
                `}
            </style>
    </div>
    );    
}